module.exports = __webpack_public_path__ + "6f4e24e75ca17ece104a6dba25f40776.png";